// The sentences still read off a refusal, from the flow before the new billing
// one (Billing:NewFlow). A wrong email or password is answered with the code
// INVALID_CREDENTIALS, which the login page reads first (login/loginFailures.js);
// its sentence only covers a backend that does not send the code yet, and goes
// once every backend does. The same goes for an unconfirmed email and its code
// EMAIL_NOT_CONFIRMED.

/** The account's email has not been confirmed. */
export const isUnconfirmedEmailMessage = (message) =>
   message === "User has not confirmed their email!";

/** The email or the password is wrong. */
export const isInvalidLoginMessage = (message) => message === "Invalid login attempt!";

/**
 * POST /Account/refreshToken with the new flow off, for an organization whose
 * latest subscription is cancelled, inactive (a failed payment included) or
 * past its end date. It comes with no code: the old flow has none.
 */
export const isSubscriptionEndedMessage = (message) =>
   message === "Subscription has ended try to login for more details";
